import { Component, OnInit } from '@angular/core';
import { ModalService } from 'src/app/services/modal.service';

@Component({
  selector: 'app-response',
  templateUrl: './response.component.html',
  styleUrls: ['./response.component.scss']
})
export class ResponseComponent implements OnInit {

  message!: any

  constructor(
    private modalService: ModalService
  ) { }

  ngOnInit(): void {
  }

  dismiss(){
    this.modalService.hideResponseModal();
  }

}
